import { useRegionConfig } from "in_queue/contexts/ClusterContext";
import { ProjectBase } from "in_queue/types/projectType";
import { MisoPercentageReduction } from "in_queue/types/scenarioType";
import { Fragment } from "react";
import { ProjectSizePreview } from "../ProjectSizePreview";

interface ProjectSizePreviewWrapperProps {
    erisReduction: number;
    nrisReduction: number;
    project: ProjectBase;
    percentageReduction: MisoPercentageReduction;
}

export const ProjectSizePreviewWrapper: React.FC<
    ProjectSizePreviewWrapperProps
> = ({
    erisReduction,
    nrisReduction,
    project,
    percentageReduction
}: ProjectSizePreviewWrapperProps) => {
    const config = useRegionConfig();

    if (erisReduction === nrisReduction) {
        return (
            <Fragment key={project.projectId}>
                downsized by {erisReduction}%{" "}
                <ProjectSizePreview
                    projectSize={project?.size}
                    percentageReduction={percentageReduction}
                    sizesToShow="both"
                />
            </Fragment>
        );
    }

    return (
        <Fragment key={project.projectId}>
            downsized by {erisReduction}% {config.sizeLabel.energyLabel}{" "}
            <ProjectSizePreview
                projectSize={project?.size}
                percentageReduction={percentageReduction}
                sizesToShow="eris"
            />
            , {nrisReduction}% {config.sizeLabel.capacityLabel}{" "}
            <ProjectSizePreview
                projectSize={project?.size}
                percentageReduction={percentageReduction}
                sizesToShow="nris"
            />
        </Fragment>
    );
};
